import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import { AppPermission, AppRole } from '../types';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission?: AppPermission;
  requiredRole?: AppRole;
  anyOfPermissions?: AppPermission[];
  redirectTo?: string;
}

export function RoleProtectedRoute({
  children,
  requiredPermission,
  requiredRole,
  anyOfPermissions,
  redirectTo = '/'
}: ProtectedRouteProps) {
  const { isLoading, hasRole, hasPermission, hasAnyPermission } = usePermissions();
  const location = useLocation();

  if (isLoading) {
    return <div className="flex h-screen w-screen items-center justify-center">Carregando permissões...</div>;
  }

  // Role check
  if (requiredRole && !hasRole(requiredRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  // Single permission check
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to={redirectTo} replace />;
  }

  // Multiple permissions check (OR)
  if (anyOfPermissions && !hasAnyPermission(anyOfPermissions)) {
    return <Navigate to={redirectTo} replace />;
  }

  // Authorized
  return <>{children}</>;
}
